import React, { useEffect, useState } from "react";
import { InfoWindow } from "@react-google-maps/api";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import road from "src/assets/images/icons/road.jpg";
import "./InfoWindow.css";

const CustomInfoWindow_nearby = ({ position, onCloseClick, vehicleInfo }) => {
  if (vehicleInfo?.restLat && vehicleInfo?.resLong) {
    vehicleInfo.coordinates = {
      lat: vehicleInfo.restLat,
      lng: vehicleInfo.resLong,
    };
  } else {
    vehicleInfo.coordinates = vehicleInfo.coordinates || position;
  }

  const infoWindowStyle = {
    position: "relative",
    // border: "1px solid #2c3e50",
    padding: "15px",
    borderRadius: "8px",
    backgroundColor:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.5) 76%,#17ead9 118%)",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
  };

  const headerStyle = {
    color: "#2c3e50",
    fontSize: "14px",
    fontWeight: "600",
    textAlign: "left",
  };

  const detailsStyle = {
    fontSize: "11px",
    color: "#34495e",
    marginBottom: "10px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "end",
  };

  const roadImgStyle = {
    width: "100%",
  };

  const [address, setAddress] = useState("");

  // const convertToAddress = (restLat, resLong) => {
  //   console.log("restLat===", restLat);
  //   console.log("resLong===", resLong);

  //   const geocoder = new window.google.maps.Geocoder();
  //   const latLng = { lat: restLat, lng: resLong };

  //   geocoder.geocode({ location: latLng }, (results, status) => {
  //     if (status === "OK") {
  //       if (results[0]) {
  //         setAddress(results[0].formatted_address);
  //       } else {
  //         console.log("No results found");
  //       }
  //     } else {
  //       console.log("Geocoder failed due to: " + status);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if (vehicleInfo) {
  //     convertToAddress(vehicleInfo.restLat, vehicleInfo.resLong);
  //   }
  // }, [vehicleInfo]);

  const adjustPositionUpwards = (originalPosition) => {
    const offset = 0.0005;
    return {
      lat: originalPosition.lat + offset,
      lng: originalPosition.lng,
    };
  };

  return (
    <InfoWindow
      position={adjustPositionUpwards(vehicleInfo.coordinates)}
      onCloseClick={onCloseClick}
    >
      <div style={infoWindowStyle}>
        <Link to={`/vehicle/details/${vehicleInfo?.vehicle_no}`}>
          <div className="info-window-header">
            <Tooltip title={vehicleInfo?.imei_no} placement="top" arrow>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={headerStyle}>{vehicleInfo?.vehicle_no}</div>
              </div>
            </Tooltip>
          </div>
          <div className="vehicle-make-model">
            <p style={{ fontWeight: "400", color: "#888", marginTop: "5px" }}>
              {vehicleInfo?.district_name}
            </p>
          </div>
          <hr
            style={{
              marginLeft: "-14px",
              marginRight: "-14px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          />
        </Link>

        <img
          src={road}
          alt="Road"
          style={roadImgStyle}
          className="opacity-80"
        />
        {/* <div style={detailsStyle}>{address}</div> */}
      </div>
    </InfoWindow>
  );
};

export default CustomInfoWindow_nearby;
